import { toast } from "react-toastify";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import { dsQuery } from "./query";

export const fetchDatasheetDetails = async (
  params,
  setInputStates,
  dispatch
) => {
  try {
    const [result] = await fetchQuery(`${dsQuery} WHERE observationSheet.id = ${params.id};`);
    let modifiedResult = {
      ...result,
      observationSheet_configuration:
        typeof result.observationSheet_configuration === "string"
          ? JSON.parse(result.observationSheet_configuration || "{}")
          : result.observationSheet_configuration,
     observationSheet_additionalTestDetails:
         result.observationSheet_additionalTestDetails 
          ? JSON.parse(result.observationSheet_additionalTestDetails || "{}")
          : {},
    };

    // Fetch all inwardTests separately using FIND_IN_SET ids
    const inwardTestIds = result?.observationSheet_inwardTestId; // "44,45"
    let inwardTestsList = [];
    if (inwardTestIds) {
      inwardTestsList = await fetchQuery(`SELECT inwardTests.* FROM inwardTests WHERE inwardTests.id IN (${inwardTestIds});`);
      dispatch({ field: "inwardTestsList", value: inwardTestsList });
    }
    dispatch({
      field: "datasheetDetails",
      value: modifiedResult,
    });

    let newSelectedStandardIds = modifiedResult?.observationSheet_masterUsedId || null;

    dispatch({
      field: "selectedStandardIds",
      value: newSelectedStandardIds,
    });
    
    // fileAttachment img fetch
    dispatch({
      field: "fileAttachment",
      value: result?.observationSheet_fileAttachment?.split(",") || [],
    });

    await fetchStaticReadingRows(params.id, dispatch);

    setInputStates(modifiedResult);
  } catch (error) {
    console.error("Error fetching observationSheet:", error);
  }
};

export const fetchRemarks = async (setReamrksList) => {
  try {
    const result = await fetchQuery(`SELECT label, value, id  FROM remarks`);
    setReamrksList(result);
  } catch (error) {
    console.error("Error fetching reamrks:", error);
  }
};

export const fetchUsers = async () => {
  try {
    const result = await fetchQuery(`SELECT u.*, e.name AS employeeName FROM userMaster u LEFT JOIN employees e ON u.employeeId = e.id where u.status != -1 ORDER BY u.id DESC`);
    return result || [];
  } catch (error) {
    console.error("Error fetching reamrks:", error);
  }
};

export function fetchCertificateStaticTables(
  instrumentId,
  materialTestings_id,
  deletedTableIds = "",
  dispatch
) {
  let url = BASE_URL;
  return axiosWithToken
    .get(url + `certificateTemplates?_where=(materialId,eq,${instrumentId})`)
    .then((res) => {
      // pre process res.data
      res.data = res.data.map((table) => {
        return {
          ...table,
          defaultConfiguration: JSON.parse(table?.defaultConfiguration || null),
        };
      });

      dispatch({
        field: "certificateStaticTables",
        value: res.data,
      });

      return res;
    })
    .catch((err) => {
      console.error("certificate static tables data fetching error: ", err);
      return err;
    });
}

export function fetchDatasheetStaticTables(
  instrumentId,
  materialTestings_id,
  deletedTableIds,
  setDerivedColumns,
  setTableConfig,
  dispatch,
  table_id
) {
  let url = BASE_URL;
  deletedTableIds = deletedTableIds?.split(",")?.map((id) => Number(id));

  let data_url = table_id
    ? `observationTemplates/${table_id}`
    : `observationTemplates?_where=(materialId,eq,${instrumentId})~and(testId,eq,${materialTestings_id})~and(status,eq,1)`;
  return axiosWithToken
    .get(url + data_url)
    .then((res) => {
      if (deletedTableIds) {
        res.data = res.data.filter((row) => !deletedTableIds.includes(row.id));
      }
      if (res.data.length > 0) {
        let tmp = {};
        let cMap = {};
        res.data.map((table) => {
          tmp[table.id] = {
            isUncertainty: table.isUncertainty,
            isVerticalUncertainty: table.isVerticalUncertainty,
            isAutomated: table.isAutomated,
            defaultValues: JSON.parse(table.defaultConfiguration)?.values,
          };
          cMap[table.id] = Object.keys(
            JSON.parse(table.defaultConfiguration).formulas
          );
        });

        // pre process res.data
        res.data = res.data.map((table) => {
          return {
            ...table,
            defaultConfiguration: JSON.parse(
              table?.defaultConfiguration || null
            ),
          };
        });

        dispatch({
          field: "staticTables",
          value: res.data,
        });
        setDerivedColumns({ ...cMap });
        setTableConfig(tmp);
      } else {
        dispatch({
          field: "staticTables",
          value: [],
        });
        setDerivedColumns({});
        setTableConfig({});
      }

      // additionalTestDetails 
      const allAdditionalTestDetails = res.data.flatMap(({ additionalTestDetails }) => {
        try {
          const parsed = JSON.parse(additionalTestDetails);
          return Array.isArray(parsed) ? parsed.map(({ label }) => label) : [];
        } catch {
          return [];
        }
      });
      dispatch({
        field: "additionalTestDetails",
        value: allAdditionalTestDetails, 
      });
    })
    .catch((err) => {
      console.error(
        "[ERROR] Failed to fetch datasheet static tables, error: ",
        err
      );
      return err;
    });
}

export async function previousObservationJobNumber(
  datasheetId,
  datasheetDetails,
  datasheetStaticReadings,
  dispatch,
  selectedMasterORNot,
  autoLoadCount = 0
) {
  try {
    const { DUCID, make, model, ranges, lc, instrumentId, deletedTableIds } =
      datasheetDetails || {};

    const formattedRanges = ranges.replaceAll("#", "_");
    const formattedLc = lc.replaceAll("#", "_");

    const query = `SELECT * FROM datasheetview WHERE status = 1 AND clientId = ${datasheetDetails?.clientId} AND totalReadings > 0 AND id != ${datasheetId} AND instrumentId = ${instrumentId} AND DUCID = '${DUCID}' AND make = '${make}' AND model = '${model}' AND ranges LIKE '${formattedRanges}' AND lc LIKE '${formattedLc}'`;

    const res = await axiosWithToken.post(BASE_URL + "dynamic", {
      query: query.trim(),
    });
    const matchedDatasheets = res?.data || [];

    if (!matchedDatasheets || matchedDatasheets.length === 0) {
      alert("No matching datasheet found to auto-load.");
      return;
    }

    // Get the current datasheet based on passed index
    const selectedIndex = autoLoadCount % matchedDatasheets.length;
    const matchedDatasheet = matchedDatasheets[selectedIndex];

    // Clear previous readings
    const readingIds = datasheetStaticReadings
      .filter((e) => e.datasheetId === datasheetId)
      .map((row) => row.id);

    if (readingIds.length > 0) {
      // await clearPreviousReadings("datasheetStaticReadings", "datasheetId", datasheetId);
    }
    // Load readings from matched datasheet
    await fetchStaticReadingRows(
      matchedDatasheet.id,
      dispatch,
      true,
      datasheetId,
      deletedTableIds,
      selectedMasterORNot
    );

    alert(
      `Auto-loaded readings from Job Number: ${matchedDatasheet.JobNumber} (${
        selectedIndex + 1
      } of ${matchedDatasheets.length})`
    );
  } catch (error) {
    console.error("Auto-load failed:", error);
  }
}

export function fetchUnits(disciplineId, dispatch) {
  return axiosWithToken
    .get(
      BASE_URL +
        "unit?_where=(status,eq,1)" +
        (disciplineId ? `~and(disciplineId,eq,${disciplineId})` : "")
    )
    .then((res) => {
      let unitSymbols = res.data.reduce((prev, current) => {
        return [...prev, current.symbol];
      }, []);
      unitSymbols = [...new Set(unitSymbols)];

      dispatch({
        field: "units",
        value: res.data,
      });

      dispatch({
        field: "unitSymbols",
        value: unitSymbols,
      });
    })
    .catch((err) => {
      console.error("unit fetching error: ", err);
      return err;
    });
}

export const fetchDisciplineDetails = (id, dispatch) => {
  axiosWithToken
    .get(
      BASE_URL +
        `xjoin?_join=ds.observationSheet,_j,ins.materialScope,_j,disc.discipline&_on1=(ds.instrumentId,eq,ins.id)&_on2=(ins.disciplineId,eq,disc.id)&_fields=disc.documentNumber,disc.issueNo,disc.issueDate,disc.amendmentNo,disc.amendmentDate&_where=(disc.id,eq,${id})`
    )
    .then((res) => {
      dispatch({
        field: "disciplineDetails",
        value: {
          documentNumber: res.data[0]?.disc_documentNumber || "",
          issueNo: res.data[0]?.disc_issueNo || "",
          issueDate: res.data[0]?.disc_issueDate || "",
          amendmentNo: res.data[0]?.disc_amendmentNo || "",
          amendmentDate: res.data[0]?.disc_amendmentDate || "",
        },
      });
    });
};

export function fetchStaticReadingRows(
  datasheetId,
  dispatch,
  isAutoload = false,
  currentDatasheetId = 0,
  deletedTableIds = "",
  selectedMasterORNot = false
) {
  let url = BASE_URL;
  let datasheetReadingsQuery;
  // for static datasheet
  if (isAutoload) {
    datasheetReadingsQuery = `SELECT * FROM datasheetReadingView where observationSheetId = ${datasheetId} `;
  } else {
    datasheetReadingsQuery = `select * from observationSheetReadings where observationSheetId = ${datasheetId}`;
  }
  if (deletedTableIds) {
    datasheetReadingsQuery += ` and tableId not in(${deletedTableIds})`;
  }

  return Promise.all([
    axiosWithToken
      .post(BASE_URL + `dynamic`, { query: datasheetReadingsQuery })
      .then((res) => {
        // if isAutoload is true, then change datasheetId to currentDatasheetId, and set id to 0
        if (isAutoload) {
          res.data = res.data.map((e) => {
            e.observationSheetId = datasheetId;
            e.id = 0;
            return e;
          });
        }
        if (selectedMasterORNot) {
          res.data = res.data.map((data) => {
            return {
              ...data,
              standardRanges: null,
              supportiveRanges: null,
            };
          });
        }
        dispatch({
          field: "datasheetStaticReadings",
          value: res.data,
        });
      })
      .catch((err) => {
        console.error(
          "[ERROR] Failed to load datasheet reading rows, error: ",
          err
        );
      }),
  ]);
}

export function fetchStandardMaster(materialTestings_id, dispatch) {

  let SQLQuery = {
    query: `SELECT em.*, emv.id AS version_id, emv.equipmentMasterId AS version_equipmentMasterId, emv.versionNumber AS version_versionNumber, emv.certificateNo AS version_certificateNo, emv.calibrationLab AS version_calibrationLab, emv.calDate AS version_calDate, emv.dueDate AS version_dueDate, emv.certificateUrl AS version_certificateUrl, emv.status AS version_status FROM materialTestings mt INNER JOIN equipmentsMaster em ON FIND_IN_SET(em.id, mt.masterEquipmentId) LEFT JOIN equipmentsMasterVersions emv ON emv.equipmentMasterId = em.id WHERE mt.id =  ${materialTestings_id}`,
  };
  return axiosWithToken
    .post(BASE_URL + "dynamic", SQLQuery)
    .then((res) => {
      let newstandardMasterArray = res.data;

      dispatch({
        field: "standardMasterArray",
        value: newstandardMasterArray,
      });
    })
    .catch((err) => {
      console.error("standardMasterArray fetching error: ", err);
      return err;
    });
}

export const fetchbeforeAutoloadJobNumber = async () => {
  try {
    // your logic here
  } catch (error) {
    console.error("Error in fetchbeforeAutoloadJobNumber:", error);
  }
};

export const fetchafterAutoloadJobNumber = async () => {
  try {
    // your logic here
  } catch (error) {
    console.error("Error in fetchafterAutoloadJobNumber:", error);
  }
};

const processData = (settings, dispatch) => {
  let _settings = {};
  settings?.forEach((setting) => {
    _settings[setting.keyName] = setting.value;
  });
  dispatch({
    field: "settings",
    value: _settings,
  });
};

export function fetchSettings(dispatch) {
  try {
    axiosWithToken
      .get(BASE_URL + `settings?_where=(status,eq,1)`)
      .then((res) => {
        processData(res.data, dispatch);
      });
  } catch (err) {
    console.log("Setting:", err);
  }
}

export const fetchUserOptions = async (setUserOptions) => {
  try {
    const userQuery = `SELECT u.id, u.userName, e.name AS employeeName FROM userMaster u LEFT JOIN employees e ON u.employeeId = e.id where u.status != -1 and u.type IN (4, 11) ORDER BY u.id DESC`;
    const userResult = await fetchQuery(userQuery);
    const users = userResult.map((u) => ({ id: u.id, label: u.employeeName + " (" + u.userName + ")" }));
    const options = [
      { id: null, label: "Withdraw Job" },
      ...users,
    ];
    setUserOptions(options);
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};

export const handleUserAssign = async (user, idsToAssign) => {
  if (!user || !idsToAssign?.length) return;
  const assignedUserValue = user.id == 0 ? null : user.id;
  const currentDateTime = new Date().toLocaleString("sv-SE").replace("T", " ");
  try {
    await fetchQuery(
      `UPDATE observationSheet SET jobAssignedUser = ${assignedUserValue}, jobAssignedDate = '${currentDateTime}' WHERE id IN (${idsToAssign.join(",")});`
    );

    const url = BASE_URL + "jobAssignHistory";
    for (const observationSheetId of idsToAssign) {
      const inputStates = {
        observationSheetId,
        userId: assignedUserValue,
        assignDate: currentDateTime,
      };
      await axiosWithToken.post(url, inputStates);
    }

    toast("Job assigned successfully!");
    window.location.reload();
  } catch (error) {
    console.error("Error assigning user:", error);
  }
};

// fetchWitnessHistory
export const fetchWitnessHistory = async (observationSheetId) => {
  if (!observationSheetId) return;
  try {
    const result = await fetchQuery(`SELECT * FROM ObservationWitnessHistory WHERE observationSheetId = ${observationSheetId} ORDER BY id DESC`);
    return result || [];
  } catch (error) {
    console.log(error);
  }
};